<template>
<div>
  <div class="page-header">
    <div class="add-item d-flex">
      <div class="page-title">
        <h6>{{ $t('edit_configuration') }}</h6>
      </div>
    </div>
    <ul class="table-top-head">
      <li>
        <div class="page-btn">
          <router-link to="/setting/list" class="btn btn-added">
            <span>Back</span>
          </router-link>
        </div>
      </li>
      <li>
        <a data-bs-toggle="tooltip" data-bs-placement="top" title="Collapse" id="collapse-header"><i class="ti ti-chevron-up"></i></a>
      </li>
    </ul>
  </div>

  <form @submit.prevent="updateSetting" enctype="multipart/form-data">
    <div class="card">
      <div class="card-body add-product pb-0">
        <div class="accordion-card-one accordion" id="accordionExample">
          <div class="accordion-item">
            <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
              <div class="accordion-body">
                <div class="row">
                  <!-- Batch Policy -->
                  <div class="col-lg-6 col-md-6 mb-3">
                    <label class="form-label">{{ $t("batch_policy") }}</label>
                    <select v-model="setting.batch_policy" class="form-select">
                      <option value="FIFO">FIFO</option>
                      <option value="FEFO">FEFO</option>
                    </select>
                    <div v-if="errors.batch_policy" class="text-danger mt-1">{{ errors.batch_policy }}</div>
                  </div>

                  <!-- Discount Policy (accounting) -->
                  <div class="col-lg-6 col-md-6 mb-3">
                    <label class="form-label">{{ $t("discount_policy") }}</label>
                    <select v-model="setting.discount_policy" class="form-select">
                      <option value="Record in Accounts">Record in Accounts</option>
                      <option value="Show Only on Invoice">Show Only on Invoice</option>
                    </select>
                    <div v-if="errors.discount_policy" class="text-danger mt-1">{{ errors.discount_policy }}</div>
                  </div>

                  <!-- Global Discount Percentage -->
                  <div class="col-lg-6 col-md-6 mb-3">
                    <label class="form-label">{{ $t("global_discount_percentage") }}</label>
                    <input
                      type="number"
                      step="0.01"
                      min="0"
                      max="100"
                      v-model="setting.global_discount_percentage"
                      class="form-control"
                      placeholder="e.g., 10.00"
                    >
                    <div v-if="errors.global_discount_percentage" class="text-danger mt-1">
                      {{ errors.global_discount_percentage }}
                    </div>
                  </div>

                  <!-- Discount Source Policy (FK) -->
                  <div class="col-lg-6 col-md-6 mb-3">
                    <label class="form-label">{{ $t("discount_source_policy") }}</label>
                    <select v-model="setting.discount_source_policy" class="form-select">
                      <option
                        v-for="policy in discountPolicies"
                        :key="policy.id"
                        :value="policy.id"
                      >
                        {{ policy.name }}
                      </option>
                    </select>
                    <div v-if="errors.discount_source_policy" class="text-danger mt-1">
                      {{ errors.discount_source_policy }}
                    </div>
                  </div>

                  <!-- Vat Percentage -->
                  <div class="col-lg-6 col-md-6 mb-3">
                    <label class="form-label">{{ $t("global_vat_percentage") }}</label>
                    <input
                      type="number"
                      step="0.01"
                      min="0"
                      max="100"
                      v-model="setting.global_vat_percentage"
                      class="form-control"
                      placeholder="e.g., 15.00"
                    >
                    <div v-if="errors.vat_percentage" class="text-danger mt-1">{{ errors.vat_percentage }}</div>
                  </div>

                  <!-- Vat Policy (FK) -->
                  <div class="col-lg-6 col-md-6 mb-3">
                    <label class="form-label">{{ $t("vat_policy") }}</label>
                    <select v-model="setting.vat_policy" class="form-select">
                      <option
                        v-for="policy in vatPolicies"
                        :key="policy.id"
                        :value="policy.id"
                      >
                        {{ policy.name }}
                      </option>
                    </select>
                    <div v-if="errors.vat_policy" class="text-danger mt-1">{{ errors.vat_policy }}</div>
                  </div>

                  <!-- Invoice style (FK) -->
                  <div class="col-lg-6 col-md-6 mb-3">
                    <label class="form-label">{{ $t("invoice_style") }}</label>
                    <select v-model="setting.invoice_style" class="form-select">
                      <option
                        v-for="style in invoiceStyles"
                        :key="style.id"
                        :value="style.id"
                      >
                        {{ style.name }}
                      </option>
                    </select>
                    <div v-if="errors.invoice_style" class="text-danger mt-1">{{ errors.invoice_style }}</div>
                  </div>

                  <!-- Selling Price Policy (FK) -->
                  <div class="col-lg-6 col-md-6 mb-3">
                    <label class="form-label">{{ $t("selling_price_policy") }}</label>
                    <select v-model="setting.selling_price_policy" class="form-select">
                      <option
                        v-for="policy in sellingPricePolicies"
                        :key="policy.id"
                        :value="policy.id"
                      >
                        {{ policy.name }}
                      </option>
                    </select>
                    <div v-if="errors.selling_price_policy" class="text-danger mt-1">
                      {{ errors.selling_price_policy }}
                    </div>
                  </div>

                  <!-- Invoice Rounding Policy (FK) -->
                  <div class="col-lg-6 col-md-6 mb-3">
                    <label class="form-label">{{ $t("invoice_rounding_policy") }}</label>
                    <select v-model="setting.invoice_rounding_policy" class="form-select">
                      <option
                        v-for="policy in invoiceRoundingPolicies"
                        :key="policy.id"
                        :value="policy.id"
                      >
                        {{ policy.name }}
                      </option>
                    </select>
                    <div v-if="errors.invoice_rounding_policy" class="text-danger mt-1">
                      {{ errors.invoice_rounding_policy }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-12 text-end">
      <div class="btn-addproduct mb-4">
        <button type="button" class="btn btn-cancel me-2" @click="cancelForm">{{ $t('cancel') }}</button>
        <button type="submit" class="btn btn-submit">{{ $t('submit') }}</button>
      </div>
    </div>
  </form>
</div>
</template>


<script>
import apiUrls from "@/urls";
import Vue3Datepicker from 'vue3-datepicker';
import {useToast} from "vue-toastification";

export default {
  components: {
    Vue3Datepicker,
  },

  props: ['id'],

  data() {
    return {
      setting: {
        batch_policy: 'FIFO',
        discount_policy: 'Show Only on Invoice',
        global_discount_percentage: 0,
        discount_source_policy: null,
        global_vat_percentage: null,
        vat_policy: null,
        invoice_style: null,
        selling_price_policy: null,
        invoice_rounding_policy: null,
      },
      discountPolicies: [],
      vatPolicies: [],
      invoiceStyles: [],
      sellingPricePolicies: [],
      invoiceRoundingPolicies: [],
      errors: {},
      errorMessage: "",
    };
  },

  setup() {
    const toast = useToast()
    return {toast}
  },

  mounted() {
    this.fetchLookupOptions();
    this.fetchSetting();
  },

  methods: {
    async fetchLookupOptions() {
      try {
        const [discountRes, vatRes, invoiceRes, sellingPriceRes, roundingRes] = await Promise.all([
          this.$axios.get(apiUrls.inv_discount_policy.get),
          this.$axios.get(apiUrls.inv_vat_policy.get),
          this.$axios.get(apiUrls.inv_invoice_style.get),
          this.$axios.get(apiUrls.inv_selling_price_policy.get),
          this.$axios.get(apiUrls.inv_invoice_rounding_policy.get),
        ]);
        this.discountPolicies = discountRes.data;
        this.vatPolicies = vatRes.data;
        this.invoiceStyles = invoiceRes.data;
        this.sellingPricePolicies = sellingPriceRes.data;
        this.invoiceRoundingPolicies = roundingRes.data;
      } catch (error) {
        this.toast.error('Error fetching configuration options');
      }
    },

    async fetchSetting() {
      try {
        const response = await this.$axios.get(`${apiUrls.setting.get}${this.id}/`);
        this.setting = response.data;
        if (this.setting.discount_source_policy != null) {
          this.setting.discount_source_policy = Number(this.setting.discount_source_policy);
        }
        if (this.setting.vat_policy != null) {
          this.setting.vat_policy = Number(this.setting.vat_policy);
        }
        if (this.setting.invoice_style != null) {
          this.setting.invoice_style = Number(this.setting.invoice_style);
        }
        if (this.setting.selling_price_policy != null) {
          this.setting.selling_price_policy = Number(this.setting.selling_price_policy);
        }
        if (this.setting.invoice_rounding_policy != null) {
          this.setting.invoice_rounding_policy = Number(this.setting.invoice_rounding_policy);
        }
      } catch (error) {
        this.toast.error(this.$t('error_fetching_settings'));
      }
    },

    async updateSetting() {
      this.errors = {};
      if (!this.setting.batch_policy) this.errors.batch_policy = this.$t('error.required');

      if (Object.keys(this.errors).length > 0) {
        return;
      }

      try {
        await this.$axios.put(apiUrls.setting.update(this.id), this.setting);

        this.toast.success('inventory setting successfully updated!')

        this.$router.push('/setting/list');

        this.$emit("create_success");

        this.resetForm();
      } catch (error) {
        if (error.response?.data?.error) {
          this.errorMessage = error.response.data.error;
        }

        if (error.response?.data?.errors) {
          this.errors = error.response.data.errors;
        }
      }
    },

    cancelForm() {
      this.$router.push('/setting/list');
    },

    resetForm() {
      this.setting = {
        batch_policy: 'FIFO',
        discount_policy: 'Show Only on Invoice',
        global_discount_percentage: 0,
        discount_source_policy: null,
        global_vat_percentage: null,
        vat_policy: null,
        invoice_style: null,
        selling_price_policy: null,
        invoice_rounding_policy: null,
      };
      this.errors = {};
      this.errorMessage = "";
    }
  },
};
</script>
